window.lastProductChange = {};
export function resetTracking() {
    window.lastProductChange = {};
}

export function setProductTracking(name, category, price, quantity) {
    const args = `${name}-${category}-${price}-${quantity}`;
    if (window.lpTag?.sdes && window.lastProductChange[category] != args) {

        window.lastProductChange[category] = args;

        window.lpTag.sdes.push({
            type: "prodView",
            currency: "USD",
            products: [{
                product: {
                    name: name,
                    category: category,
                    sku: '',
                    price
                }
            }],
            quantity
            // products: formatCartInfo(floatCartObj)
        })
        console.log("lpmetrics setProductTracking", arguments);
    }
}

export function setCartTracking(floatCartObj) {
    try {
        if (window.lpTag?.sdes) {
            const productsInfo = formatCartInfo(floatCartObj);
            const productObj = {
                type: "cart",
                total: Number(floatCartObj?.planDetails?.headerInfo?.Price?.replace(/[^0-9\.]+/g, "")),
                numItems: productsInfo?.length - 1,
                currency: "USD",
                products: productsInfo
            };
            window.lpTag.sdes.push(productObj);
            console.log("lpmetrics setCartTracking", floatCartObj, formatCartInfo(floatCartObj), productObj);
        }
    } catch (err) {
        console.log('setCartTracking - Catch Error', err);
    }
}

export function setPurchaseTracking(floatCartObj, orderNumber) {
    try {
    if (window.lpTag?.sdes) {
        const purchaseTracker = {
            type: "purchase",
            total: Number(floatCartObj?.planDetails?.headerInfo?.Price?.replace(/[^0-9\.]+/g, "")),
            currency: "USD",
            orderId: orderNumber,
            cart: {
                products: formatCartInfo(floatCartObj)
            }
        }
        window.lpTag.sdes.push(purchaseTracker)
        console.log("lpmetrics setPurchaseTracking", purchaseTracker);
    }
    } catch (err) {
        console.log('setPurchaseTracking - Catch Error', err);
    }
}



export function formatCartInfo(floatCartObj) {
    const prdarray = [];
    try {
    if (floatCartObj) {
        const { planDetails } = floatCartObj;
        if (planDetails) {
            if (planDetails.headerInfo) {
                const headerInfo = planDetails.headerInfo;
                const productinfo = {
                    product: {
                        name: headerInfo?.Title,
                        category: "Title",
                        sku: "",
                        price: Number(headerInfo?.Price?.replace(/[^0-9\.]+/g, "")),
                    },
                };

                prdarray.push(productinfo);
            }
            if (planDetails.dataInfo) {
                const productinfo =
                {
                    product: {
                        name: planDetails?.dataInfo?.planName,
                        category: "Internet",
                        sku: "",
                        price: Number(planDetails?.dataInfo?.planPrice?.replace(/[^0-9\.]+/g, "")),
                    },
                    quantity: 1
                };

                prdarray.push(productinfo);
            }
            if (planDetails.phoneInfo) {    
                const productinfo = {
                    product: {
                        name: planDetails?.phoneInfo?.planName,
                        category: "Phone Service - Account Level Info",
                        sku: "",
                        price: Number(planDetails?.phoneInfo?.planPrice?.replace(/[^0-9\.]+/g, "")),
                    },
                    quantity: 1
                };
                prdarray.push(productinfo);
                if (planDetails.phoneInfo.lines) {
                    const LineLevelLen = planDetails?.phoneInfo?.lines?.length;
                    for (let i = 0; i < LineLevelLen; i++) {
                        const productinfo = {
                            product: {
                                name: planDetails?.phoneInfo?.lines[i]?.planName,
                                category: "Phone Service - Line Level Info",
                                sku: planDetails?.phoneInfo?.lines[i]?.TN,
                                price: Number(planDetails.phoneInfo?.lines[i]?.total?.replace(/[^0-9\.]+/g, "")),
                            },
                            quantity: 1
                        };
                        prdarray.push(productinfo);
                    }
                }
                if (planDetails.phoneInfo.phoneServices) {
                    const AccountLevelLen = planDetails.phoneInfo?.phoneServices?.length;
                    for (let i = 0; i < AccountLevelLen; i++) {
                        const productinfo = {
                            product: {
                                name: planDetails.phoneInfo?.phoneServices[i]?.Name,
                                category: "Phone Service - Account Level Info",
                                sku: '',
                                price: Number(planDetails.phoneInfo?.phoneServices[i]?.Rc?.replace(/[^0-9\.]+/g, "")),
                            },
                            quantity: 1
                        };
                        prdarray.push(productinfo);
                    }
                }
                if (planDetails.phoneInfo.FaxLine) {
                    const Faxlineslen = planDetails.phoneInfo?.FaxLine?.length;
                    for (let i = 0; i < Faxlineslen; i++) {
                        const productinfo = {
                            product: {
                                name: planDetails.phoneInfo?.FaxLine[i]?.prdName,
                                category: "Phone Service - Fax Line Info",
                                sku: '',
                                price: Number(planDetails.phoneInfo?.FaxLine[i]?.Price?.replace(/[^0-9\.]+/g, "")),
                            },
                            quantity: 1
                        };
                        prdarray.push(productinfo);
                    }
                }
            }
            if (planDetails.tvInfo) {
                const tvTitleProductinfo = {
                    product: {
                        name: planDetails.tvInfo?.planName,
                        category: "TV  Service - Account Level Info",
                        sku: '',
                        price: Number(planDetails.tvInfo?.planPrice?.replace(/[^0-9\.]+/g, "")),
                    },
                    quantity: 1
                };
                // {
                //     productName: planDetails.tvInfo.planName,
                //     productPrice: planDetails.tvInfo.planPrice,
                //     productQty: '',
                //     productId: '',
                //     productType: 'TV  Service - Account Level Info',
                //     movieChannelsPackPrice: planDetails.tvInfo.movieChannelsPackPrice ,
                //     subTotalTvServices: planDetails.tvInfo.subTotalTvServices,
                // };
                prdarray.push(tvTitleProductinfo);
                if (planDetails.tvInfo.tvServices) {
                    for (let i = 0; i < planDetails.tvInfo.tvServices?.length; i++) {
                        const tvProductInfo =
                        {
                            product: {
                                name: planDetails.tvInfo?.tvServices[i]?.prdName,
                                category: "TV  Service ",
                                sku: '',
                                price: Number(planDetails.tvInfo?.tvServices[i]?.Price?.replace(/[^0-9\.]+/g, "")),
                            },
                            quantity: 1
                        };

                        prdarray.push(tvProductInfo);
                    }
                }
                if (planDetails.tvInfo.movieChannelsPack) {
                    for (let i = 0; i < planDetails.tvInfo.movieChannelsPack?.length; i++) {
                        const mcProductInfo =
                        {
                            product: {
                                name: planDetails.tvInfo.movieChannelsPack[i]?.channelName,
                                category: "TV Movie Channel Service Info ",
                                sku: '',
                                price: ''
                            },
                            quantity: 1
                        };

                        prdarray.push(mcProductInfo);
                    }
                }
            }
            if (planDetails.otherServices) {
                for (let i = 0; i < planDetails.otherServices?.length; i++) {
                    let productQty = '';
                    if (planDetails.otherServices[i].Product.indexOf("BlueJeans") > -1) {
                        const noOfLicences = planDetails.BlueJeanInfo ? planDetails.BlueJeanInfo.NumberOfLicenses : '';
                        if (noOfLicences) {
                            productQty = noOfLicences.split(" ")[0];
                        }
                    }
                    const osProductInfo =
                    {
                        product: {
                            name: planDetails.otherServices[i]?.Product,
                            category: "Other Services Info ",
                            sku: '',
                            price: Number(planDetails?.otherServices[i]?.price?.replace(/[^0-9\.]+/g, "")),
                        },
                        quantity: productQty || 1,
                    };
                    if (planDetails.otherServices[i]?.Product.indexOf("BlueJeans") > -1) {
                        osProductInfo.productInfo = planDetails?.BlueJeanInfo;
                    }
                    prdarray.push(osProductInfo);
                }
            }
            if (planDetails.equipmentAndOnetimeCharges) {
                for (let i = 0; i < planDetails.equipmentAndOnetimeCharges?.length; i++) {
                    let productQty = '';
                    const equipProductInfo = {
                        product: {
                            name: planDetails.equipmentAndOnetimeCharges[i]?.offerName,
                            category: "Equipments and One Time charges ",
                            sku: '',
                            price: Number(planDetails.equipmentAndOnetimeCharges[i]?.price?.replace(/[^0-9\.]+/g, "")),
                        },
                        quantity: 1
                    };
                    // {
                    //         productName: planDetails.equipmentAndOnetimeCharges[i].offerName, 
                    //         productPrice: planDetails.equipmentAndOnetimeCharges[i].price, 
                    //         productQty:'',
                    //         productId:'',
                    //         productType:'Equipments and One Time charges',
                    //         wavied: planDetails.equipmentAndOnetimeCharges[i].wavied,
                    //         type: planDetails.equipmentAndOnetimeCharges[i].type
                    //     };
                    prdarray.push(equipProductInfo);
                }
            }
            // if(planDetails.BlueJeanInfo) {
            //     const blueJeanInfo =  {
            //         productName: planDetails.BlueJeanInfo.productName, 
            //         productPrice: planDetails.BlueJeanInfo.productPrice, 
            //         productQty:'',
            //         productId:planDetails.BlueJeanInfo.productID,
            //         productType:'BlueJean',
            //         wavied: '',
            //         type: planDetails.BlueJeanInfo.type,
            //         productDetails: planDetails.BlueJeanInfo
            //     };
            //     prdarray.push(blueJeanInfo);
            // }
            if (planDetails.firstMonthServiceCharges) {
                // TBD
            }
            if (planDetails.taxAndotherChargespro) {
                // TBD
            }
        }

    }
    } catch (err) {
        console.log('formatCartInfo - Catch Error', err);
    }
    return prdarray;
}

export function formatOmniCartResponse(getOmniCartInfoSuccessResponse) {
    const { OmniInternetInfo, OmniPhoneInfo, OmniEquipmentOneTimeInfo, OmniBBEInfo, OmniPromoInfo } = getOmniCartInfoSuccessResponse;
    const productArray = [];
    try {

    /* Internet */
    if (OmniInternetInfo) {
        const productInfo =
        {
            product: {
                name: OmniInternetInfo?.DataDescription,
                category: "Internet",
                sku: '',
                price: Number(OmniInternetInfo?.DataPrice?.replace(/[^0-9\.]+/g, "")),
            },
            quantity: 1
        }

        productArray.push(productInfo);

        if (OmniInternetInfo.OtherService) {
            OmniInternetInfo.OtherService.map((product) => {

                const productInfo = {
                    product: {
                        name: product.Key,
                        category: "Internet - Other Services",
                        sku: '',
                        price: Number(product?.Value?.replace(/[^0-9\.]+/g, "")),
                    },
                    quantity: 1
                }
                productArray.push(productInfo);
            })
        }
    }

    if (OmniPhoneInfo) {

        if (OmniPhoneInfo.PhoneDescPrice) {
            OmniPhoneInfo.PhoneDescPrice.map((product) => {
                const productInfo = {
                    product: {
                        name: product?.Key,
                        category: OmniPhoneInfo?.PhoneLineType,
                        sku: '',
                        price: Number(product?.Value?.replace(/[^0-9\.]+/g, "")),
                    },
                    quantity: 1
                };

                productArray.push(productInfo);
            })
        }

        if (OmniPhoneInfo.OtherService) {
            OmniPhoneInfo.OtherService.map((product) => {

                const productInfo = {
                    product: {
                        name: product?.Key,
                        category: 'Phone - Other Services',
                        sku: '',
                        price: Number(product?.Value?.replace(/[^0-9\.]+/g, "")),
                    },
                    quantity: 1
                };
                productArray.push(productInfo);
            })
        }

    }

    /* Equipment and one time charges */
    if (OmniEquipmentOneTimeInfo?.EquipmentsAndOneTime) {
        OmniEquipmentOneTimeInfo.EquipmentsAndOneTime.map((product) => {

            const productInfo = {
                product: {
                    name: product?.Key,
                    category: 'Equipment and one time charges',
                    sku: '',
                    price: product?.Value
                },
                quantity: 1
            };
            productArray.push(productInfo);
        })
    }

    /* Broadband esssentials and extras */
    if (OmniBBEInfo) {
        OmniBBEInfo.map((product) => {
            const productInfo = {
                product: {
                    name: product?.BBEDescription,
                    category: 'Broadband esssentials and extras',
                    sku: '',
                    price: Number(product?.BBEPrice?.replace(/[^0-9\.]+/g, ""))
                },
                quantity: 1
            };
            productArray.push(productInfo);
        })
    }

    if (OmniPromoInfo) {
        OmniPromoInfo.map((product) => {
            const productInfo = {
                product: {
                    name: product?.PromoDescription,
                    category: 'Promotions and credits',
                    sku: '',
                    price: Number(product?.PromoValue?.replace(/[^0-9\.]+/g, ""))
                },
                quantity: ''
            };
            productArray.push(productInfo);
        })
    }
    } catch (err) {
        console.log('formatOmniCartResponse - Catch Error', err);
    }
    return productArray;
}